// data/items/logs.js
// Woodcutting logs

export const LOGS = [
    { id: 'common_timber', name: 'Common Timber', color: '#8b4513', value: 3,
      sprite: { sheet: 'assets/icons/woodcutting/common_timber_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'ironwood_logs', name: 'Ironwood Logs', color: '#a0522d', value: 8,
      sprite: { sheet: 'assets/icons/woodcutting/ironwood_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'softbark_logs', name: 'Softbark Logs', color: '#9acd32', value: 15,
      sprite: { sheet: 'assets/icons/woodcutting/softbark_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'goldleaf_logs', name: 'Goldleaf Logs', color: '#ff8c00', value: 40,
      sprite: { sheet: 'assets/icons/woodcutting/goldleaf_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'redgrain_logs', name: 'Redgrain Logs', color: '#d2691e', value: 60,
      sprite: { sheet: 'assets/icons/woodcutting/redgrain_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'gravewood_logs', name: 'Gravewood Logs', color: '#228b22', value: 85,
      sprite: { sheet: 'assets/icons/woodcutting/gravewood_log.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'arcanewood_logs', name: 'Arcanewood Logs', color: '#9370db', value: 115,
      sprite: { sheet: 'assets/icons/woodcutting/arcanewood_log.png', x: 0, y: 0, width: 64, height: 64 } }
];

export default LOGS;
